import React from 'react'
import Button from './Button';

const CreateCustomerForm = ({ isOpen, onClose, onSubmit }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        // logic to handle form submission
        // send a request to add a new customer
        onSubmit(); // Call the onSubmit function passed from the parent component
      };

  return (
    <>
      {isOpen && (
        <form className="customer-form flex flex-col gap-5" onSubmit={handleSubmit}>
          {/* Form fields for new customer */}
          <section className='flex gap-10'>
            <label htmlFor="" className='flex flex-col'>First Name
                <input type="text" placeholder='Enter first name' className='mt-2'/>
            </label>
            <label htmlFor="">Last Name
                <input type="text" placeholder='Enter last name' className='mt-2'/>
            </label>
          </section>
          <section className='flex gap-10'>
            <label htmlFor="" className='flex flex-col'>Phone Number
                <input type="text" placeholder='Enter phone number' className='mt-2'/>
            </label>
            <label htmlFor="">Email Address
                <input type="text" placeholder='Enter email' className='mt-2'/>
            </label>
          </section>
          <label htmlFor="" className="mt-2">
                Laundry Preference
                <textarea name="" id="" cols="30" rows="10" className="mt-2" placeholder="Add customer preferences"></textarea>
          </label>
          <label htmlFor="" className="mt-2">
                Notes
                <textarea name="" id="" cols="30" rows="10" className="mt-2" placeholder="Any additional notes"></textarea>
          </label>

          <section className='flex create-customer-btn'>
            <Button type="button" style={{'padding': '8px 16px', 'background': 'none', 'color': '#434C5A', 'fontWeight': '400', 'fontSize': '1.4rem'}} onClick={onClose}>Cancel</Button>
            <Button type="submit" style={{'padding': '8px 16px', 'fontWeight': '400', 'fontSize': '1.4rem'}}>Add Customer</Button>
          </section>
          
        </form>
      )}
    </>
  )
}

export default CreateCustomerForm